// The exact strings components/WorkFlowStatus switches on. Anything else
// renders no badge at all, silently — always use these constants.
export const STATUS = {
  IN_PROGRESS: "In Progress",
  TESTING: "Testing",
  FINISHED: "Finished",
  LIVE: "Live",
  COMING_SOON: "Coming Soon",
};
